<template>
  <div>
    <span v-if=!question.id>
      Die Frage must erst gespeichert werden
    </span>
    <!-- WITH IMAGE -->
    <div v-else-if=question.image>
      <a :href="'//' + question.imagePath + '/' + question.id + '/' + question.image " target="_blank">
        <img :src="'//' + question.imagePath + '/' + question.id + '/' + question.image "/>
      </a>

      <div class="text-right">
        <b-button variant="danger" size="sm" v-on:click="deleteImage">
          <font-awesome-icon icon="trash-alt"></font-awesome-icon>
        </b-button>
      </div>
    </div>

    <!-- WITHOUT IMAGE -->
    <div v-else>
      <b-form-file name="imgUpload"
                   id="imgUpload"
                   ref="imgUpload"
                   v-model="file"
                   placeholder="jpg oder png auswählen..."
                   accept="image/png, image/jpeg"
      ></b-form-file>

      <b-button type="button" variant="primary" v-on:click="uploadImage" :disabled=!this.file>
        hochladen
      </b-button>
    </div>
  </div>
</template>
<script>

export default {
  name: 'QuestionImg',
  props: ['competition', 'question'],
  data: function () {
    return {
      file: null
    }
  },

  methods: {
    uploadImage: function () {
      let formData = new FormData()
      formData.append('file', this.file, this.file.name)

      let request = {
        method: 'POST',
        url: '/questions/' + this.question.id + '/image',
        data: formData
      }

      this.axios.request(request)
        .then(() => {
          this.question.image = this.file.name
        })
        .catch((err) => {
          this.$eventHub.$emit('alertError', err)
        })
    },

    deleteImage: function () {
      this.axios.delete('/questions/' + this.question.id + '/image')
        .then(() => {
          this.question.image = ''
        })
        .catch((err) => {
          this.$eventHub.$emit('alertError', err)
        })
    }
  }
}
</script>
<style scoped>
img {
  float: left;
  max-width: 100px;
  max-height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/competitions/admin/QuestionImg.vue